/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/Sms/Name/Content"
  
}) {
  let isMedia = useIsMedia()
let threadNameValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'name',
})
let threadInboundNotificationValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'inbound_notification',
format: fromFormat.phoneNumberUS,
})
let threadNumbersMobileNumbersInboundValueData = fromData.useDataValue({ viewPath,
context: 'thread_numbers',
path: 'mobile_numbers_inbound',
})
let constantData = 'No patient match'
let aggregateData = fromHelpers.smsThreadName(threadNameValueData, threadInboundNotificationValueData, threadNumbersMobileNumbersInboundValueData, constantData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="thread.name"
 data="thread.inbound_notification"
 format="/Data/format.js phoneNumberUS"
 data="thread_numbers.mobile_numbers_inbound"
 data="'No patient match'"
 aggregate="./helpers.js smsThreadName"
 text={aggregateData}
 size={isMedia.mobile ? "small" : "large"}
 weight="semibold"
 whiteSpace="wrap"
 maxWidth={isMedia.mobile ? "30%" : "60%"}
 overflowX="hidden"
/>
{children}
</React.Fragment>)
}